import type { Table } from "mdast";

type InlineNode = {
  type: string;
  value?: string;
  alt?: string | null;
  children?: readonly InlineNode[];
};

export function getTableCellText(node: InlineNode): string {
  if (typeof node.value === "string") return node.value;
  if (node.type === "break") return "\n";
  if (node.type === "image") return node.alt ?? "";
  return node.children?.map(getTableCellText).join("") ?? "";
}

/** Balance compact fields and prose without letting one long value dominate the table. */
export function getTableColumnWidths(table: Table, totalWidth: number): number[] {
  const columnCount = table.children[0]?.children.length ?? 0;
  if (columnCount === 0) return [];

  const weights = Array.from({ length: columnCount }, (_, column) =>
    Math.min(32, table.children.reduce((longest, row) => {
      const cell = row.children[column];
      return Math.max(longest, cell ? getTableCellText(cell).length : 0);
    }, 8)),
  );
  const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
  const widths = weights.map(weight => Math.floor(totalWidth * weight / totalWeight));
  const remainder = Math.round(totalWidth) - widths.reduce((sum, width) => sum + width, 0);
  for (let index = 0; index < remainder; index++) widths[index % columnCount] += 1;
  return widths;
}
